import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Header } from './header';
import { AxiosInstance } from '../utils';
import { Footer } from './footer';

export const EventPageContent = () => {
    const { eventcode, pagename } = useParams<{ eventcode: string; pagename: string }>();
    const [eventInfo, setEventInfo] = useState<any>(null);
    const [pageContent, setPageContent] = useState<string>('');
    const [pageTitle, setPageTitle] = useState<string>('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string>('');

    useEffect(() => {
        if (!eventcode) return;
        
        const fetchData = async () => {
            setLoading(true);
            try {
                // Fetch event details
                const eventResp = await AxiosInstance.get('/api/getevent?eventcode=' + eventcode);
                if (eventResp.data.result === 'Success' && eventResp.data.data) {
                    setEventInfo(eventResp.data.data[0]);
                }

                // Fetch page content from storage (public API, no auth)
                // Storage paths are lowercase, so convert the URL param
                if (pagename) {
                    const storagePath = `pages/${eventcode}/${pagename.toLowerCase()}`;
                    const { data } = await AxiosInstance.get('/api/getpublicpage', { 
                        params: { path: storagePath } 
                    });
                    setPageContent(data.content || '');
                    setPageTitle(pagename.replace(/_/g, ' ').replace(/\b\w/g, (c: string) => c.toUpperCase()));
                }
            } catch (error) {
                console.error('Error fetching page:', error);
                setError('Page not found');
            }
            setLoading(false);
        };

        fetchData();
    }, [eventcode, pagename]);

    if (loading) {
        return (
            <div className="antialiased light-vz circle-v">
                <Header eventInfo={eventInfo} />
                <div id="preloader">
                    <div id="status">
                        <div className="spinner"></div>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="antialiased light-vz circle-v">
                <Header eventInfo={eventInfo} />
                <section className="register-sec sec-padding">
                    <div className="container">
                        <div className="sec-title">
                            <h3>Page Not Found</h3>
                        </div>
                        <div className="register-sec-details" style={{ textAlign: 'center', padding: '40px 20px' }}>
                            <p>The requested page could not be found.</p>
                            <a href={`/event/${eventcode}`} className="btn-default">Back to Event</a>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        );
    }

    return (
        <div className="antialiased light-vz circle-v">
            <Header eventInfo={eventInfo} />
            <section className="register-sec sec-padding">
                <div className="container">
                    <div className="sec-title">
                        <h3>{pageTitle}</h3>
                    </div>
                    <div className="register-sec-details" style={{ padding: '20px' }}>
                        <div className="event-page-content-wrapper" dangerouslySetInnerHTML={{ __html: pageContent }} />
                    </div>
                </div>
            </section>
            <Footer />

            <style>{`
                .event-page-content-wrapper {
                width: 100%;
                font-size: 16px;
                line-height: 1.7;
                color: #333;
                }
                
                .event-page-content-wrapper * {
                max-width: 100%;
                box-sizing: border-box;
                }

                .event-page-content-wrapper div {
                    width: 100%;
                    max-width: 100%;
                    overflow-x: auto;
                    word-wrap: break-word;
                    overflow-wrap: break-word;
                }

                /* Clearfix for floated elements inside dynamic content */
                .event-page-content-wrapper::after {
                    content: '';
                    display: table;
                    clear: both;
                }

                .event-page-content-wrapper img {
                    max-width: 100%;
                    display: block;
                    width: auto;
                    height: auto !important;
                    margin: 20px auto;
                    border-radius: 6px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
                    float: none !important;
                }

                /* Ensure text after floated images doesn't overlap */
                .event-page-content-wrapper p,
                .event-page-content-wrapper div:not([class]) {
                    overflow: visible;
                }

                .event-page-content-wrapper iframe,
                .event-page-content-wrapper video,
                .event-page-content-wrapper embed {
                    max-width: 100%;
                    width: 100%;
                    aspect-ratio: 16 / 9;
                    border: none;
                    border-radius: 6px;
                    margin: 1.5rem 0;
                }

                .event-page-content-wrapper table {
                    width: 100%;
                    max-width: 100%;
                    border-collapse: collapse;
                    display: block;
                    overflow-x: auto;
                    white-space: nowrap;
                    margin: 1.5rem 0;
                    font-size: 14px;
                }

                .event-page-content-wrapper table th,
                .event-page-content-wrapper table td {
                    padding: 10px 14px;
                    border: 1px solid #ddd;
                    text-align: left;
                    min-width: 120px;
                }

                .event-page-content-wrapper table th {
                    background-color: #f5f5f5;
                    font-weight: 600;
                }
                .event-page-content-wrapper h1,
                .event-page-content-wrapper h2,
                .event-page-content-wrapper h3,
                .event-page-content-wrapper h4,
                .event-page-content-wrapper h5,
                .event-page-content-wrapper h6 {
                    margin: 1.5rem 0 0.75rem 0;
                    line-height: 1.3;
                    word-wrap: break-word;
                    overflow-wrap: break-word !important;
                }
                .event-page-content-wrapper div> h1,
                .event-page-content-wrapper div> h2,
                .event-page-content-wrapper div> h3,
                .event-page-content-wrapper div> h4,
                .event-page-content-wrapper div> h5,
                .event-page-content-wrapper div> h6 {
                    margin: 1.5rem 0 0.75rem 0;
                    line-height: 1.3;
                    word-wrap: break-word;
                    overflow-wrap: break-word !important;
                }

                .event-page-content-wrapper h1 { font-size: 1.75rem; }
                .event-page-content-wrapper h2 { font-size: 1.5rem; }
                .event-page-content-wrapper h3 { font-size: 1.25rem; }
                .event-page-content-wrapper h4 { font-size: 1.15rem; }
                .event-page-content-wrapper h5 { font-size: 1.05rem; }
                .event-page-content-wrapper h6 { font-size: 1rem; }

                .event-page-content-wrapper p {
                    margin: 0 0 1rem 0;
                    word-wrap: break-word;
                    overflow-wrap: break-word;
                }

                .event-page-content-wrapper a {
                    color: #007bff;
                    text-decoration: underline;
                    word-wrap: break-word;
                    overflow-wrap: break-word;
                }

                .event-page-content-wrapper ul,
                .event-page-content-wrapper ol {
                    margin: 0 0 1rem 0;
                    padding-left: 2rem;
                }

                .event-page-content-wrapper li {
                    margin-bottom: 0.4rem;
                    line-height: 1.6;
                }

                .event-page-content-wrapper blockquote {
                    margin: 1.5rem 0;
                    padding: 0.75rem 1.25rem;
                    border-left: 4px solid #007bff;
                    background-color: #f8f9fa;
                    border-radius: 0 6px 6px 0;
                    font-style: italic;
                }

                .event-page-content-wrapper pre,
                .event-page-content-wrapper code {
                    max-width: 100%;
                    overflow-x: auto;
                    white-space: pre-wrap;
                    word-wrap: break-word;
                }

                .event-page-content-wrapper pre {
                    background-color: #f4f4f4;
                    padding: 1rem;
                    border-radius: 6px;
                    font-size: 14px;
                    border: 1px solid #e0e0e0;
                }

                .event-page-content-wrapper code {
                    background-color: #f0f0f0;
                    padding: 2px 6px;
                    border-radius: 3px;
                    font-size: 0.9em;
                }

                .event-page-content-wrapper pre code {
                    background: none;
                    padding: 0;
                    border-radius: 0;
                }

                /* Mobile adjustments */
                @media (max-width: 768px) {
                    .event-page-content-wrapper {
                        font-size: 15px;
                        line-height: 1.6;
                    }

                    .event-page-content-wrapper h1 { font-size: 1.5rem; }
                    .event-page-content-wrapper h2 { font-size: 1.35rem; 
                    word-wrap: break-word;
                    overflow-wrap: break-word !important;}
                    .event-page-content-wrapper h3 { font-size: 1.15rem; }

                    .event-page-content-wrapper img {
                        margin: 1rem auto;
                        border-radius: 4px;
                    }

                    .event-page-content-wrapper iframe,
                    .event-page-content-wrapper video {
                        aspect-ratio: 16 / 9;
                        margin: 1rem 0;
                    }

                    .event-page-content-wrapper table {
                        font-size: 13px;
                    }

                    .event-page-content-wrapper table th,
                    .event-page-content-wrapper table td {
                        padding: 8px 10px;
                        min-width: 100px;
                    }

                    .event-page-content-wrapper blockquote {
                        margin: 1rem 0;
                        padding: 0.5rem 1rem;
                    }

                    .event-page-content-wrapper pre {
                        padding: 0.75rem;
                        font-size: 13px;
                    }
                }

                @media (max-width: 480px) {
                    .event-page-content-wrapper {
                        font-size: 14px;
                    }

                    .event-page-content-wrapper h1 { font-size: 1.3rem; }
                    .event-page-content-wrapper h2 { font-size: 1.2rem; }
                    .event-page-content-wrapper h3 { font-size: 1.05rem; }

                    .event-page-content-wrapper ul,
                    .event-page-content-wrapper ol {
                        padding-left: 1.5rem;
                    }

                    .event-page-content-wrapper img {
                        margin: 0.75rem auto;
                    }
                }
            `}</style>
        </div>
    );
};